<template>
  <div
    class="qr-code"
    :link="link"
  >
    <div class="qr-code__title">
      <div>{{ $t('camera-focus-qr-code') }}</div>
      <div>{{ $t('scan-to-install-app') }}</div>
    </div>
    <div
      v-loading="canvasLoading"
      class="qr-code-box"
    >
      <canvas
        id="qr-code__content"
        ref="qrCodeRef"
      />
    </div>
  </div>
</template>

<script
  lang="ts"
  setup
>
import { useDomain } from '#imports'
import QRCode from 'qrcode'
import {
  onMounted,
  ref,
} from 'vue'

interface PropsInterface {
  link?: string;
}

const props = defineProps<PropsInterface>()

const qrCodeRef = ref(null)
const canvasLoading = ref(false)
const renderQrCode = async () => {
  try {
    canvasLoading.value = true
    const renderUrl = props.link || `https://${useDomain().value}`
    await QRCode.toCanvas(qrCodeRef.value, renderUrl)
  } catch (err) {
    console.error('[renderQrCode: ]', err)
  }
  canvasLoading.value = false
}

onMounted(() => {
  renderQrCode()
})

</script>

<style
  lang="less"
  scoped
>
.qr-code {
  position: relative;
  max-width: 292px;
  max-height: 292px;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2.58483px 12.9242px rgba(13, 37, 83, 0.1);
  box-sizing: border-box;
  border: 1px solid transparent;

  &__title {
    font-size: 12px;
    font-weight: 400;
    line-height: 17px;
    text-align: center;
    color: #000;
    margin-top: 8px;
  }

  .qr-code-box {
    position: relative;
    max-width: 104px;
    height: 104px;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 10px;
  }

  #qr-code__content {
    position: absolute;
    width: 130px !important;
    height: 130px !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
